import React, { useState, useEffect } from 'react';
import { TicketRow } from "../../../common/components/TicketRow";
import { PassCodeRow } from "../../../common/components/PassCodeRow";
import './TicketsTable.scss';
import { usePickerCore } from "../../hooks/usePickerCore";
import { useTicketsBuilder } from "../../hooks/useTicketsBuilder";
import { usePickerContext } from "../../hooks/usePickerContext"
import {AssuranceChoice} from "../../../common/components/AssuranceChoice";

export function TicketsTable({ assurances, onAssuranceChange }) {

    const { state } = usePickerContext();
    const { deleteTicket, changeFormulaTicket, changePassTicket } = usePickerCore();
    const { tickets, total: baseTotal } = useTicketsBuilder({
        onlyCurrentDate: true
    });
    const [selectedAssuranceData, setSelectedAssuranceData] = useState(null);
    const [total, setTotal] = useState(baseTotal);

    useEffect(() => {
        let assuranceTotal = 0;

        if (selectedAssuranceData) {
            assuranceTotal = selectedAssuranceData.modeCalcul === 'P'
                ? (baseTotal * selectedAssuranceData.pvente) / 100
                : parseFloat(selectedAssuranceData.pvente);
        }

        setTotal(baseTotal + assuranceTotal);
    }, [baseTotal, selectedAssuranceData]);

    const handleAssuranceChange = (assuranceData) => {
        setSelectedAssuranceData(assuranceData);
        onAssuranceChange(assuranceData);
    };

    return (
        <section className={"PickerContainer-section TicketsTable-container"}>
            <header className="PickerContainer-sectionHeader">
                <span className={"h3 TicketsTable-title"}>{state.translations.PLC_MY_TICKETS} ({tickets.length}) :</span>
            </header>
            <table className={"TicketsTable"}>
                <thead>
                <tr>
                    <th>{state.translations.PLC_TBL_BILLETS_CATEGORIE}</th>
                    <th>{state.translations.PLC_TBL_BILLETS_PLACE}</th>
                    <th>{state.translations.PLC_TBL_BILLETS_FORMULE}</th>
                    <th>{state.translations.PLC_TBL_BILLETS_PRIX}</th>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {tickets.map((ticket, index) => (
                    <React.Fragment key={index}>
                        <TicketRow
                            {...ticket}
                            onDelete={() => deleteTicket(ticket)}
                            onChangeFormula={formula => changeFormulaTicket(ticket, formula)}
                            onInputPassCode={passCode => changePassTicket(ticket, passCode)}
                        />
                        {ticket.passCode != null && state.otiPassCode == null && (
                            <PassCodeRow
                                {...ticket}
                                onInputPassCode={passCode => changePassTicket(ticket, passCode)}
                            />
                        )}
                    </React.Fragment>
                ))}

                </tbody>
                {assurances && (
                    <AssuranceChoice
                        assurances={assurances}
                        onAssuranceChange={handleAssuranceChange}
                    />
                )}
                <thead>

                <tr>
                    <th colSpan={3}>{state.translations.PLC_TBL_BILLETS_TOTAL} :</th>
                    <th colSpan={3}>{total.toFixed(2)}€</th>
                </tr>
                </thead>
            </table>
        </section>
    )
}